<kzn-dialog title="Open mobile app?"
  actionLabel="Open app"
  secondaryActionLabel="Continue in browser"
  (actionFired)="openMobileApp()"
  (secondaryActionFired)="continueInBrowser()">
  <span>Would you like to open the mobile app?</span>
</kzn-dialog>